import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { getDocument } from "@faire/web--source/common/globals/getDocument";
import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { logError } from "@faire/web--source/common/logging";
import { shouldRetryEndpoint } from "@faire/web--source/common/shouldRetryEndpoint";
import throttle from "lodash/throttle";
export var BatchEventsQueue = function BatchEventsQueue() {
    "use strict";
    var _this = this;
    var retry_timeout_multiplier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 100;
    var _this1 = this;
    _class_call_check(this, BatchEventsQueue);
    var _this2 = this;
    this.retry_timeout_multiplier = retry_timeout_multiplier;
    this._queue = [];
    this.flush = /*#__PURE__*/ _async_to_generator(function() {
        var sendEventPromise;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!_this2._queue.length) {
                        return [
                            2
                        ];
                    }
                    sendEventPromise = _this2.sendEvents(_this2._queue);
                    _this2._queue = [];
                    return [
                        4,
                        sendEventPromise
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    this.enqueueEvent = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(event) {
            return _ts_generator(this, function(_state) {
                _this2._queue.push(event);
                return [
                    2,
                    _this2.throttledFlush()
                ];
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
    this.throttledFlush = throttle(this.flush, 16, {
        leading: false
    });
    this.sendEvents = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(events) {
            var error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            _this2.batchEvents(events)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        _this2.catchAndRetry(events, error);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(events) {
            return _ref.apply(this, arguments);
        };
    }();
    this.catchAndRetry = function(events, error) {
        var retryCounter = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        return new Promise(function(resolve) {
            setTimeout(function() {
                if (shouldRetryEndpoint(retryCounter, error)) {
                    _this1.batchEvents(events).then(resolve).catch(function(error) {
                        return _this1.catchAndRetry(events, error, retryCounter + 1);
                    });
                } else {
                    logError("Error for batching-events. Lost ".concat(events.length), {
                        data: {
                            events: events,
                            error: error
                        }
                    });
                }
            // Wait 100, 400, 900, 1600
            }, _this1.retry_timeout_multiplier * (retryCounter + 1) * (retryCounter + 1));
        });
    };
    var window = getWindow();
    if (window && "addEventListener" in window && typeof window.addEventListener === "function") {
        window.addEventListener("visibilitychange", function() {
            var _getDocument;
            if (((_getDocument = getDocument()) === null || _getDocument === void 0 ? void 0 : _getDocument.visibilityState) === "hidden") {
                _this.flush();
            }
        });
    }
};
